import React from 'react';
import Container from './Container';

const cx = (...c) => c.filter(Boolean).join(' ');

const PAD = { lg: 'py-20 md:py-28', md: 'py-14 md:py-20', sm: 'py-10 md:py-14', none: '' };
const TONE = { white: 'bg-white', cream: 'bg-cream', ink: 'bg-ink text-white/80' };

/** Vertical-rhythm band. tone = full-bleed background. */
const Section = ({
  children, tone = 'white', pad = 'lg', id, className, container = true,
}) => (
  <section id={id} className={cx(TONE[tone], PAD[pad], className)}>
    {container ? <Container>{children}</Container> : children}
  </section>
);

export default Section;
